import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function AccountMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

);

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Financial Accounting</h5>

<div className="row">

<MenuCard link="/add-bank" title="Add Bank" icon="fa-solid fa-building-columns" color="#0d6efd"/>

<MenuCard link="/add-deposit" title="Add Deposit" icon="fa-solid fa-money-bill-transfer" color="#20c997"/>

<MenuCard link="/add-cheque" title="Add Cheque" icon="fa-solid fa-money-check" color="#fd7e14"/>

<MenuCard link="/account-report" title="Bank Statement" icon="fa-solid fa-file-invoice" color="#6f42c1"/>

</div>

</section>

)

}

export default AccountMenu;